import * as React from 'react';
import { gql } from '@apollo/client';
import {
  useDeleteTimeslotMutation,
  useGetCategoriesQuery,
  useGetSocialProfilesQuery,
  useGetTimeslotsQuery
} from '../../../models/graphql';
import { PostingPlanController, PostingPlanControllerProps } from './PostingPlan.controller';
import { useContext } from 'react';
import { AppContext } from '../../../providers/AppProvider';
import { useRequiredQueries } from '../../../hooks/useRequiredQueries';

export type PostingPlanApolloProps = Omit<
  PostingPlanControllerProps,
  | 'getSocialProfiles'
  | 'socialProfileResults'
  | 'getCategories'
  | 'categoryResults'
  | 'getTimeslots'
  | 'timeslotsResults'
  | 'deleteTimeslot'
  | 'updateTimeslot'
> & {
  // ...
};

gql`
  query GetTimeslots($workspaceId: ID!) {
    workspace(workspaceId: $workspaceId) {
      id
      timeslots {
        ...CoreTimeslotFields
        category {
          id
          name
          color
        }
        socialProfiles {
          id
        }
      }
    }
  }

  mutation DeleteTimeslot($timeslotId: ID!) {
    deleteTimeslot(timeslotId: $timeslotId)
  }
`;

export const PostingPlanApollo = (props: PostingPlanApolloProps): JSX.Element => {
  const { selectedWorkspaceId } = useContext(AppContext);
  const socialProfileResults = useGetSocialProfilesQuery({
    variables: { workspaceId: selectedWorkspaceId as string }
  });
  const categoryResults = useGetCategoriesQuery({
    variables: { workspaceId: selectedWorkspaceId as string }
  });
  const timeslotsResults = useGetTimeslotsQuery({
    variables: { workspaceId: selectedWorkspaceId as string }
  });
  const [deleteTimeslot] = useDeleteTimeslotMutation();
  useRequiredQueries([categoryResults, timeslotsResults]);

  const controllerProps: PostingPlanControllerProps = {
    ...props,
    socialProfileResults,
    categoryResults,
    timeslotsResults,
    deleteTimeslot
  };

  return <PostingPlanController {...controllerProps} />;
};
